import { Pressable, View, Text } from "react-native";
import CircleIcon from "@/assets/icons/main/circleIcon.svg";

interface ICustomRadioButtonProps<T> {
  label: string;
  value: T;
  selectedValue: T | null;
  onSelect: (value: T) => void;
}

const radioButtonBlockClass: string = "flex-row items-center mb-3 p-3 rounded-xl border";
const radioButtonClass: string = "items-center justify-center w-5 h-5 rounded-full mr-3";

const CustomRadioButton = <T,>({
  label,
  value,
  selectedValue,
  onSelect,
}: ICustomRadioButtonProps<T>) => {
  const isSelected: boolean = selectedValue === value;

  return (
    <Pressable
      onPress={() => onSelect(value)}
      className={`${radioButtonBlockClass} ${isSelected ? "border-blue-500" : "border-gray-300"}`}
    >
      <View className={`${radioButtonClass} ${isSelected ? "bg-blue-500" : "border border-gray-400"}`}>
        {isSelected && <CircleIcon  />}
      </View>
      <Text className="text-base"> {label?.length > 65 ? `${label?.slice(0, 65)}...` : label}</Text>
    </Pressable>
  );
};

export default CustomRadioButton;
